module.exports = __webpack_public_path__ + "img/3Fragezeichen.ff7af8b6.jpg";